import PromotionChallengeTransactionList from './PromotionChallengeTransactionList'
import { withPromotionChallengeTransactionList } from './withPromotionChallengeTransactionList'

const ConnectedPromotionChallengeTransactionList =
  withPromotionChallengeTransactionList(PromotionChallengeTransactionList)

export { ConnectedPromotionChallengeTransactionList as PromotionChallengeTransactionList }
